import { LKDate } from 'loankeeper-common/helpers/Date'

const config = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'grd_man_reserve',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    ResDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    AutResRate: {
      cellStyle: { textAlign: 'right' },
    },
  },

  getContextMenuItems: () => [],
}

export default config
